'use strict';

class ContactOverviewCtrl {

    constructor ( $rootScope, $http, $window, $timeout, $mdDialog, $mdToast, $state, Contact, $filter, itemFilters, filterMap, paginationService ) {

        // Dependencies
        this.$http = $http;
        this.$timeout = $timeout;
		this.$mdDialog = $mdDialog;
		this.$mdToast = $mdToast;
		this.$state = $state;
		this.$window = $window;
		this.paginationService = paginationService;
		this.paginationId = this.paginationService.getLastInstanceId();
		this._Contact = Contact;

		// Controller vars
		this.$filter = $filter;
		this.itemFilters = itemFilters;
		this.filterMap = filterMap;
		this.loaded = false;

		// Watchers
		$rootScope.checkActive = (contact) => {
			return contact.id == $state.params.contactId;
		};

        // Paginator
        this.pagination = {
            current: 1
        };

        // Fetch the overview items
        if ($state.params.contactId) {
            $http.get('/contacts/findpage/'+ $state.params.contactId).then((response) => {
                this.fetch(response.data);
                this.pagination.current = response.data;
            });
        } else {
            this.fetch(1);
        }

    }

	fetch(pageNumber) {

		let filters = [];
		this.filterMap.map((filter) => {

			if (filter.enabled) {
				filters.push(filter.id);
			}
		});

		this.loaded = false;
		this.$http.get('/contacts_overview/?page=' + (pageNumber || 1) +'&filters='+ filters)
			.then((response) => {
				this.contacts = response.data.data;
				this.totalResults = response.data.total;
				this.resultPerPage = response.data.per_page;
				this.$timeout(() => {
					this.loaded = true;
				});
			});

        this.$http.get('/modeltypes_options/contact')
            .then((response) => {
                this.contact_options = response.data;
            });

	}

	destroy(id,firstname, lastname , ev) {

		ev.stopPropagation();
		let pageN = this.paginationService.getCurrentPage(this.paginationId);

		this.$mdDialog.show( {

			controller: 'ConfirmDialogCtrl',
			templateUrl: 'confirmDialog.ngTemplate',
			parent: angular.element(document.querySelector('#popupContainer')),
			targetEvent: ev,
			clickOutsideToClose: true
		}).then( () => {

			this.loaded = false;
			this._Contact.delete({id: id}, () => {
				this.fetch(pageN);
				this.$state.go('contacts');
			});

			this.$mdToast.show({
				templateUrl: '/partial/app.partials.toasts.delete?object=contact&title='+firstname+'%20'+lastname, //@trans('labels.contact')
				hideDelay: 3000,
				position: ('top right')
			});
		});
	}

	/**
	 * Returns true or false depending on if the item.model_type_id is in the filterArray
	 * @param  {object} item
	 * @return {boolean}
	 */
	updateFilters() {

		let filters = [];
		this.filterMap.map((filter) => {

			if (!filter.enabled) {
				filters.push(filter.id);
			}
		});

		this.$http.post('/userfilters/contact', {
			contact_filter: filters
		}).then(() => {
			this.fetch(1);
		});
	}

    callPhone(number){
        this.$window.open("tel:" + number, "_self");
    }
}


ContactOverviewCtrl.$inject = [

	'$rootScope',
	'$http',
    '$window',
	'$timeout',
	'$mdDialog',
	'$mdToast',
	'$state',
	'Contact',
	'$filter',
	'itemFilters',
	'filterMap',
	'paginationService'
];


module.exports = ContactOverviewCtrl;
